import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

type Props = {
  tagId: string;
  packageVulnId: string;
  enabled?: boolean;
};

const SECURITY_IMAGE_PACKAGE_VULNERABILITIES_QUERY_KEY =
  'security-image-package-vulnerabilities';

const getImagePackageVulnerabilitiesQueryKey = (params?: {
  tagId: string;
  packageVulnId: string;
}) =>
  [
    SECURITY_IMAGE_PACKAGE_VULNERABILITIES_QUERY_KEY,
    params?.tagId,
    params?.packageVulnId,
  ] as const;

const getImagePackageVulnerabilityDetailsQueryOptions = ({
  tagId,
  packageVulnId,
  enabled = true,
}: Props) =>
  queryOptions({
    queryKey: getImagePackageVulnerabilitiesQueryKey({ tagId, packageVulnId }),
    queryFn: async () => {
      const { data } =
        await apiClient.securityInsights.getImagePackageVulnerabilityDetails({
          tagId,
          pkgVulnId: packageVulnId,
        });
      return data;
    },
    enabled,
  });

export const useImagePackageVulnerabilityDetailsQuery = (props: Props) => {
  const {
    isLoading,
    data: vulnerabilityDetails,
    error,
    refetch,
  } = useQuery(getImagePackageVulnerabilityDetailsQueryOptions(props));
  return { isLoading, vulnerabilityDetails, error, refetch };
};
